import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";

export const parseSortingParam = (sortingParam: string): Sorting => {
  const sorting = {
    column: sortingParam,
    direction: SortingDirection.Asc,
  };
  if (sorting.column.startsWith("-")) {
    sorting.column = sorting.column.substring(1);
    sorting.direction = SortingDirection.Desc;
  }
  return sorting;
};

export const formatSortingParam = (sorting: Sorting) => {
  return sorting.direction == SortingDirection.Asc ? sorting.column : `-${sorting.column}`;
};
